// This has emptied out results i.e. is static
const STATIC_BALLOT_PAGE =
  'https://s3.amazonaws.com/sos-test-2.texastribune.org/2024_general/ballot_page/results_FLAT_for_ballot.json';

// What we are using across the app
const RESULTS_IN_USE = STATIC_BALLOT_PAGE;

export { RESULTS_IN_USE };